import store from "../../state/store";
import { CallEmsApi, iEmsApiResponseBody } from "../../Logic/EmsAPI/FetchExtension";
export interface UserProfileDTO {
    firstName: string;
    lastName: string;
    departmentName: string;
    externalUserID: string;
    email: string;
    globalRoleName: string;
    mailboxMembership: Array<mailboxMembership>;
}
export interface mailboxMembership {
    departmentName: string;
    roleName: string;
    mailboxName: string;
}

export async function GetUserProfileData(): Promise<iEmsApiResponseBody<UserProfileDTO>> {
    let user = store.getState().UserInformation;
    return await CallEmsApi<UserProfileDTO>("GET", `Users/${user.userID}/UserProfile`);
}
